import {
	type AgentSimpleResponseDTO,
	type TimelineTaskDataDTO,
	UserTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { z } from "zod";

export type TaskAuthor = Pick<AgentSimpleResponseDTO, "name" | "type">;
export type TaskData = Omit<TimelineTaskDataDTO, "author"> & {
	author?: TaskAuthor | null;
};

const taskDataSchema = z.object({
	title: z.string(),
	author: z
		.object({
			name: z.string(),
			type: z.nativeEnum(UserTypeEnum),
		})
		.nullish()
		.catch(null),
}) satisfies z.ZodType<TaskData, z.ZodTypeDef, unknown>;

export const parseTaskData = (data: unknown): TaskData | null => {
	const result = taskDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
